var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.58831 4.86065H9.52671V3.56335H4.15588C3.67823 3.56335 3.29102 3.95057 3.29102 4.42822V21.0409C3.29102 21.5186 3.67823 21.9058 4.15588 21.9058H20.5192C20.9968 21.9058 21.384 21.5186 21.384 21.0409V15.7616H20.0867V20.6085H4.58831V4.86065Z",
  fill: "#54595C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0833 4.84395C16.5415 3.38573 18.9058 3.38573 20.364 4.84395C21.8222 6.30217 21.8222 8.6664 20.364 10.1246L13.9115 16.5771C13.617 16.8716 13.2254 17.0489 12.8098 17.076L8.78943 17.3377C8.26835 17.3716 7.83629 16.9396 7.87021 16.4185L8.13193 12.3981C8.15898 11.9825 8.33629 11.591 8.63079 11.2965L15.0833 4.84395ZM19.4466 5.76128C18.4951 4.80969 16.9522 4.80969 16.0006 5.76128L9.54811 12.2138C9.47631 12.2856 9.43308 12.3811 9.42648 12.4824L9.19677 16.0111L12.7255 15.7814C12.8269 15.7748 12.9223 15.7316 12.9941 15.6598L19.4466 9.20729C20.3982 8.2557 20.3982 6.71287 19.4466 5.76128Z",
  fill: "#54595C"
});

function SvgEditCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCheck);
export default __webpack_public_path__ + "static/media/EditCheck.ac086329.svg";
export { ForwardRef as ReactComponent };